// Shared fatal screen for a present-but-invalid branding block. Both entry
// points refuse to render the app in that state (see src/lib/branding.ts for
// the contract), so the failure has to be visible in the browser as well as
// the console: a blank page reads as an outage, not a config error.

export function renderBrandingFailure(container: HTMLElement, error: unknown): void {
  console.error("Refusing to start: branding configuration is invalid.", error)
  const message = error instanceof Error ? error.message : String(error)
  container.replaceChildren()

  const wrapper = document.createElement("div")
  wrapper.setAttribute("role", "alert")
  wrapper.style.cssText =
    "font-family: system-ui, sans-serif; max-width: 40rem; margin: 4rem auto; padding: 0 1.5rem; color: #1a1a1e;"

  const heading = document.createElement("h1")
  heading.textContent = "Configuration error"
  heading.style.cssText = "font-size: 1.25rem; margin-bottom: 0.75rem;"

  const detail = document.createElement("p")
  // textContent, never innerHTML: the message quotes config file content.
  detail.textContent = message
  detail.style.cssText = "font-size: 0.9rem; line-height: 1.5; color: #55555e;"

  const hint = document.createElement("p")
  hint.textContent =
    "Fix the branding block in profile/config.json and redeploy. See docs/how-to/applying-the-brand-pack.md."
  hint.style.cssText = "font-size: 0.9rem; line-height: 1.5; color: #55555e; margin-top: 0.5rem;"

  wrapper.append(heading, detail, hint)
  container.appendChild(wrapper)
}
